var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDdProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.335 2.21706C10.6886 2.21706 11.7854 3.31393 11.7854 4.6675C11.7854 6.02107 10.6886 7.11794 9.335 7.11794C7.98143 7.11794 6.88456 6.02107 6.88456 4.6675C6.88456 3.31393 7.98143 2.21706 9.335 2.21706ZM9.335 12.7189C12.8006 12.7189 16.4529 14.4226 16.4529 15.1694V16.4529H2.21706V15.1694C2.21706 14.4226 5.86938 12.7189 9.335 12.7189ZM9.335 0C6.75621 0 4.6675 2.08871 4.6675 4.6675C4.6675 7.24629 6.75621 9.335 9.335 9.335C11.9138 9.335 14.0025 7.24629 14.0025 4.6675C14.0025 2.08871 11.9138 0 9.335 0ZM9.335 10.5019C6.21944 10.5019 0 12.0655 0 15.1694V18.67H18.67V15.1694C18.67 12.0655 12.4506 10.5019 9.335 10.5019Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdProfile);
export default __webpack_public_path__ + "static/media/dd-profile.c5628b1431e955886386906d965b0540.svg";
export { ForwardRef as ReactComponent };